<template>
  <!-- Card Security Code-->
  <div class="form-group inner-addon2">
    <input
      id="card_cvc"
      v-model="card_cvc"
      @change="emit('change', card_cvc)"
      autocomplete="cc-csc"
      class="creditcard-cvv"
      data-lpignore="true"
      maxlength="4"
      minlength="3"
      name="card_cvc"
      type="tel"
      @blur="onBlur"
      @focus="onFocus"
      :class="{'error': props.valid.$errors.length}"
    />
    <label for="card_cvc">{{ props.text }}</label>
    <i id="reveal" class="material-icons" v-on:click="cvc_popup = true">help</i>
    <span v-if="props.valid.$errors.length" class="error-message">
        {{ props.valid.$errors[0].$message }}
    </span>
    <div
      class="cvv_popup_overlay"
      v-bind:class="[cvc_popup ? 'open' : '']"
      @click="cvc_popup = false"
    >
      <div class="cvv_popup_wrap">
        <div class="cvv_popup_content">
          <span class="close" v-on:click="cvc_popup = false"
            ><i class="material-icons">clear</i></span
          >
          <h2 class="text-[#17072B]">
            {{ props.cvv_popup_title }}
          </h2>
          <p v-html="props.cvv_popup_html"></p>
          <p>
            <span
              ><img
                alt="card"
                class="b-loaded"
                height="120"
                :src="props.cvv_popup_image"
                width="205"
            /></span>
          </p>
          <p>
            <br /><strong>Visa&nbsp;<sup>®</sup>&nbsp;& MasterCard&nbsp;<sup>®</sup></strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref } from 'vue'
import Payment from 'payment'
import { onBlur, onFocus } from './fields.js'

const props = defineProps({
  text: String,
  cvv_popup_title: String,
  cvv_popup_html: String,
  cvv_popup_image: String,
  valid: Object
})

const emit = defineEmits(['change'])

const card_cvc = ref(null)
const cvc_popup = ref(false)

nextTick(() => {
  Payment.formatCardCVC(document.querySelector('#card_cvc'))
})
</script>

<style scoped>
.cvv_popup_overlay {
  background-color: hsla(0, 0%, 4%, 0.45);
  bottom: 0;
  display: none;
  height: 100%;
  left: 0;
  overflow: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 10000;
}

.cvv_popup_overlay.open {
  display: table;
}

.cvv_popup_overlay .close {
  color: #000;
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 1;
}

.cvv_popup_overlay .cvv_popup_wrap {
  display: table-cell;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  width: 100%;
}

.cvv_popup_overlay .cvv_popup_content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  margin: 0 auto;
  max-width: 380px;
  padding: 20px 12px;
  position: relative;
  text-align: left;
  width: 94%;
}

.cvv_popup_overlay .cvv_popup_content h2 {
  font-size: 1.8rem;
  font-weight: 400;
  margin-bottom: 5px;
}
</style>
